import {Box} from '@mui/material';
import {string} from 'prop-types';
import {Controller} from 'react-hook-form';

import {controlPropType, fieldPropType} from '../../../../proptypes-shapes';
import {buildFieldName} from '../buildFieldName';
import FieldLabel from '../field-components/EmmaiFieldLabel/EmmaiFieldLabel';
import Switch from '../field-components/Switch/Switch';

const SwitchFieldRenderer = ({control, field, prefix}) => (
  <>
    {field.label && <FieldLabel required={field.required}>{field.label}</FieldLabel>}

    <Controller
      name={buildFieldName(field, prefix)}
      control={control}
      defaultValue={false}
      render={({field: rhfField}) => (
        <Box height={35} display="flex" alignItems="center">
          <Switch {...rhfField} checked={rhfField.value} edge="end" />
        </Box>
      )}
    />
  </>
);

SwitchFieldRenderer.propTypes = {
  control: controlPropType.isRequired,
  field: fieldPropType.isRequired,
  prefix: string
};

export default SwitchFieldRenderer;
